import { DefaultDisplayValue } from 'app/enums';
import React, { FC, memo } from 'react';

interface EntriesFormatProps {
  entries: number;
}

const EntriesFormatComponent: FC<EntriesFormatProps> = ({ entries }) => {
  if (typeof entries !== 'number') {
    return <>{DefaultDisplayValue.DASH}</>;
  }

  if (!entries) {
    return <>Unlimited</>;
  }

  return <>{entries}</>;
};

export const EntriesFormat = memo(EntriesFormatComponent);
